import React from "react";

//import dom
import { BrowserRouter as Router, Link, Switch } from "react-router-dom";

//impotr libs
import { PageHeader, Tag, Table, Select, Tooltip } from "antd";
import Column from "antd/lib/table/Column";
import { EditOutlined } from "@ant-design/icons";

import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import { getTableService } from "../services/table-helper.service";



const data = [
  {
    key: 1,
    word:
      "1.แบบประเมินนี้เป็นการประเมินภาวะผู้นำและการบริหารตามหลักธรรมาภิบาลของผู้บริหาร",
    wordEN:
      "1. This form is used to evaluate the leadership and administrative capacity of Payap’s administrators in accordance with principles of good governance. ",
  },
  {
    key: 2,
    word:
      "2. ผลการประเมินที่ได้จะนำไปใช้สำหรับเป็นข้อมูลเพื่อพัฒนาภาวะผู้นำและการบริหารจัดการตามหลักธรรมาภิบาลของผู้บริหาร",
    wordEN:
      "2. The information received will be used to develop the leadership and administrative capabilities of Payap’s administrators in accordance with principles of good governance.",
  },
  {
    key: 3,
    word:
      "3. กรณีที่มีการเปลี่ยนแปลงผู้บริหาร ขอให้ท่านทำการประเมินภาวะผู้นำและการบริหารตามหลักธรรมาภิบาลของผู้บริหาร ที่ปรากฏรายชื่อในระบบประเมินของท่าน โดยประเมินเฉพาะระยะเวลาที่ผู้บริหารท่านนั้นดำรงตำแหน่ง",
    wordEN:
      "3. In case of administrators changed, please evaluate the leadership and administrative capabilities of Payap’s administrators as the indicated name in the evaluation form in accordance with the time was served.  ",
  },
  {
    key: 3,
    word:
      "4. คำชี้แจงในการตอบ: ให้ประเมินระดับความคิดเห็นของท่านที่มีต่อภาวะผู้นำและการบริหาร ตามหลักธรรมาภิบาลของผู้บริหาร โดยทำการเลือกระดับความคิดเห็นในช่องที่กำหนด ซึ่งมีความหมายของระดับความคิดเห็น ดังนี้ ",
    wordEN:
      "4. Instructions for completing the form: Please give your opinion about the leadership and administrative capabilities in accordance with principles of good governance – please put a check in the box that most expresses your agreement with the statement as it pertains to the administrator.  The meaning of the levels of agreement: ",
  },
];

const getRowKey = (record) => {
  return `${record.LeaderId}`;
};

export default class LeaderScreen extends React.Component {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    
    this.state = {
      language: localStorage.getItem("Language"),
      titleTH: "แบบประเมินภาวะผู้นำและการบริหารตามหลักธรรมาภิบาลของผู้บริหารมหาวิทยาลัยพายัพประจำปีการศึกษา 2564",
      titleEN:
        "Appraisal of administrators on their leadership and administrative capacity in accordance with principles of good governance for the Academic Year 2564 ",
        EmpListDatasource: [],
        SectorListDatasource: [],
        Columns: [],
        ColumnsDatasourceTH: [],
        ColumnsDatasourceEN: [],
        PositionList: [],
        query: "",
        results: [],
        selectedRowKeys: null,
      };

  }

  componentWillReceiveProps(nextProps){
    console.log('nextProps',nextProps)
    this.setState({language: nextProps.lang})
    localStorage.setItem("Language", nextProps.lang);
  }



  componentDidMount() {
    console.log("componentRef", this.inputRef);
    
    getTableService("leader-form").then((result) => {
      var table = [];
      result.forEach((e) => {
        this.state.Columns = e.TableColumn;
      });

      console.log("this.state.Columns", this.state.Columns);

      this.state.Columns.forEach((e) => {
        console.log("ColumnKeyTH", e.ColumnKeyTH);
        if ( e.ColumnKeyTH !== "LeaderEvalStatus" ) {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyTH == "LeaderEvalStatus") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record, index) => {
              console.log("record", index);
              if (e == 3) {
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      ประเมินผู้บังคับบัญชาสำเร็จ
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                  <Tag className="first-level" color="red">
                    ยังไม่ได้ประเมินผู้บังคับบัญชา
                  </Tag>
                  <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/leader-form/ID:" + record.LeaderId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>
                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                  <Tag className="first-level" color="volcano">
                    กำลังประเมินผู้บังคับบัญชา
                  </Tag>
                  <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/leader-form/ID:" + record.LeaderId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>

                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceTH: this.state.ColumnsDatasourceTH.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });


      // conlumns eng
      this.state.Columns.forEach((e) => {
        console.log("ColumnKeyEN", e.ColumnKeyEN);

        if ( e.ColumnKeyEN !== "LeaderEvalStatus" ) {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyEN == "LeaderEvalStatus") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            render: (e, record, index) => {
              console.log("record", index);
              if (e == 3) {
                return (
                  <div>
                    <Tag
                      className="first-level"
                      text-align="center"
                      color="green"
                    >
                      Success
                    </Tag>
                  </div>
                );
              } else if (e == 1) {
                return (
                  <div>
                  <Tag className="first-level" color="red">
                    No Record
                  </Tag>
                  <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/leader-form/ID:" + record.LeaderId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>
                  </div>
                );
              } else if (e == 2) {
                return (
                  <div>
                  <Tag className="first-level" color="volcano">
                    In Progress
                  </Tag>
                  <Tooltip color="geekblue" placement="top" title="ประเมิน">
                      <Link
                        to={{
                          pathname: "/leader-form/ID:" + record.LeaderId,
                          state: { record: record },
                        }}
                      >
                        <EditOutlined
                          onClick={() => this.assessSubInfo(record)}
                          style={{ fontSize: "15px", color: "#5399ff" }}
                        />
                      </Link>
                    </Tooltip>

                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceEN: this.state.ColumnsDatasourceEN.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });


    });

    fetch(process.env.REACT_APP_API_URL + "/api/getLeader", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result", result);
        result.forEach((element) => {
          this.state.EmpListDatasource = element.LeaderList;
        });
        
        this.setState({
          EmpListDatasource: this.state.EmpListDatasource,
        });
        console.log(
          "this.state.ColumnsDatasourceTH",
          this.state.ColumnsDatasourceTH
        );
        console.log(
          "this.state.EmpListDatasource",
          this.state.EmpListDatasource
        );

      });
  }


  assessSubInfo(record) {
    console.log('record', record)
    console.log('record.LeaderId', record.LeaderId)
  }

  positionPopper(positionName) {
    var tempDup = [];
    tempDup = this.state.PositionList.filter((e) => {
      return positionName !== e.PositionNameTH;
    });
    return tempDup;
  }


  setRowKey(record) {
    const selectedRowKey = getRowKey(record);
    console.log(selectedRowKey, typeof selectedRowKey);
    this.setState({ selectedRowKey });
  }
  

  renderTable() {
    return (
      <table id="calendar">
        {this.state.language == "TH" ? (
          <tr>
            <th>
              <b> เห็นด้วยมากที่สุด </b>
            </th>
            <th>
              <b> เห็นด้วยมาก </b>
            </th>
            <th>
              <b> เห็นด้วยปานกลาง </b>
            </th>
            <th>
              <b> เห็นด้วยน้อย </b>
            </th>
            <th>
              <b> เห็นด้วยน้อยที่สุด </b>
            </th>
          </tr>
        ) : (
          <tr>
            <th>
              <b> Strongly Agree </b>
            </th>
            <th>
              <b> Agree </b>
            </th>
            <th>
              <b> Neutral </b>
            </th>
            <th>
              <b> Disagree </b>
            </th>
            <th>
              <b> Strongly Disagree </b>
            </th>
          </tr>
        )}

        <tr>
          <td> 5 </td>
          <td> 4 </td>
          <td> 3 </td>
          <td> 2 </td>
          <td> 1 </td>
        </tr>
      </table>
    );
  }


  renderContentTH() {
    const { EmpListDatasource, ColumnsDatasourceTH } = this.state;

    var EmpListRequired = EmpListDatasource.filter((element) =>  element.required == "1")
    var EmpListRequiredCount1 = EmpListRequired.filter((element) => element.LeaderEvalStatus == '1')
    var EmpListRequiredCount = EmpListRequired.filter((element) => element.LeaderEvalStatus == '3')
    var EmpListNotRequired = EmpListDatasource.filter((element) =>  element.required == "2")

    // console.log('EmpListNotRequired', EmpListNotRequired)
    // console.log('EmpListRequiredCount1', EmpListRequiredCount1)
    // console.log('EmpListRequired', EmpListRequired)

    EmpListRequired.length == EmpListRequiredCount1.length? localStorage.setItem('leadershipEvalStatus', 1) : localStorage.setItem('leadershipEvalStatus', 2);

    if(EmpListRequired.length == EmpListRequiredCount.length){
      localStorage.setItem('leadershipEvalStatus', 3)
    }

    
    return (
      <div>

      <PageHeader
            className="site-page-header"
            onBack={() => window.history.back()}
            title={this.state.language == 'TH' ? this.state.titleTH : this.state.titleEN}
          />

        <div style={{ width: "80%", margin: "auto", marginTop: 35 }}>
          {this.state.language == "TH" ? (
            <div>
              <h3 style={{ textAlign: "center", fontWeight: "Bold" }}>
               {this.state.titleTH}
              </h3>

              <div>
                {data.map(({ key, word }) => {
                  return <p key={key}>{word}</p>;
                })}
              </div>
            </div>
          ) : (
            <div>
              <h3 style={{ textAlign: "center", fontWeight: "Bold" }}>
                {this.state.titleEN}
              </h3>
              <div>
                {data.map(({ key, wordEN }) => {
                  return <p key={key}>{wordEN}</p>;
                })}
              </div>
            </div>
          )}

          <div style={{ textAlign: "center" }}>{this.renderTable()}</div>
          

          {/* render required table */}
          <div className="tab-centered">
            <h3> ผู้บริหารที่ต้องประเมิน </h3>
              <Table
                dataSource={EmpListRequired}
                columns={ColumnsDatasourceTH}
                rowKey={(record) => getRowKey(record)}
                rowClassName={(record) =>
                  getRowKey(record) === this.state.selectedRowKey
                    ? "highlighted-selection"
                    : ""
                }
                onRow={(record) => {
                  return {
                    onClick: () => {
                      this.setState({ visible: true });
                      this.setRowKey(record);
                    },
                  };
                }}
                pagination={false}
              >
                <Column />
              </Table>
            </div>


            {/* render not required */}
              {EmpListNotRequired.length !== 0? 
               <div className="tab-centered">
               <h3>  ผู้บริหารที่เกี่ยวข้องในสายงาน (สามารถเลือกประเมินได้) </h3>
                 <Table
                   dataSource={EmpListNotRequired}
                   columns={ColumnsDatasourceTH}
                   rowKey={(record) => getRowKey(record)}
                   rowClassName={(record) =>
                     getRowKey(record) === this.state.selectedRowKey
                       ? "highlighted-selection"
                       : ""
                   }
                   onRow={(record) => {
                     return {
                       onClick: () => {
                         this.setState({ visible: true });
                         this.setRowKey(record);
                       },
                     };
                   }}
                   pagination={false}
                 >
                   <Column />
                 </Table>
               </div>
               : null

              }
           

        </div>
      </div>
    );
  }

  renderContentEN() {
    const { EmpListDatasource, ColumnsDatasourceEN, PositionList } = this.state;

    var EmpListRequired = EmpListDatasource.filter((element) =>  element.required == "1")
    var EmpListRequiredCount1 = EmpListRequired.filter((element) => element.LeaderEvalStatus == '1')
    var EmpListRequiredCount = EmpListRequired.filter((element) => element.LeaderEvalStatus == '3')
    var EmpListNotRequired = EmpListDatasource.filter((element) =>  element.required == "2")

    // console.log('EmpListNotRequired', EmpListNotRequired)
    // console.log('EmpListRequiredCount1', EmpListRequiredCount1)
    // console.log('EmpListRequired', EmpListRequired)

    EmpListRequired.length == EmpListRequiredCount1.length? localStorage.setItem('leadershipEvalStatus', 1) : localStorage.setItem('leadershipEvalStatus', 2);

    if(EmpListRequired.length == EmpListRequiredCount.length){
      localStorage.setItem('leadershipEvalStatus', 3)
    }
    
    return (
      <div>

      <PageHeader
            className="site-page-header"
            onBack={() => window.history.back()}
            title={this.state.language == 'TH' ? this.state.titleTH : this.state.titleEN}
          />

        <div style={{ width: "80%", margin: "auto", marginTop: 35 }}>
          {this.state.language == "TH" ? (
            <div>
              <h3 style={{ textAlign: "center", fontWeight: "Bold" }}>
               {this.state.titleTH}
              </h3>

              <div>
                {data.map(({ key, word }) => {
                  return <p key={key}>{word}</p>;
                })}
              </div>
            </div>
          ) : (
            <div>
              <h3 style={{ textAlign: "center", fontWeight: "Bold" }}>
                {this.state.titleEN}
              </h3>
              <div>
                {data.map(({ key, wordEN }) => {
                  return <p key={key}>{wordEN}</p>;
                })}
              </div>
            </div>
          )}

          <div style={{ textAlign: "center" }}>{this.renderTable()}</div>
          
          
      
          {/* render required table */}
          <div className="tab-centered">
            <h3> Require </h3>
              <Table
                dataSource={EmpListRequired}
                columns={ColumnsDatasourceEN}
                rowKey={(record) => getRowKey(record)}
                rowClassName={(record) =>
                  getRowKey(record) === this.state.selectedRowKey
                    ? "highlighted-selection"
                    : ""
                }
                onRow={(record) => {
                  return {
                    onClick: () => {
                      this.setState({ visible: true });
                      this.setRowKey(record);
                    },
                  };
                }}
                pagination={false}
              >
                <Column />
              </Table>
            </div>


            {/* render not required */}
            {EmpListNotRequired.length !== 0? 
               <div className="tab-centered">
               <h3> Optinal </h3>
                 <Table
                   dataSource={EmpListNotRequired}
                   columns={ColumnsDatasourceEN}
                   rowKey={(record) => getRowKey(record)}
                   rowClassName={(record) =>
                     getRowKey(record) === this.state.selectedRowKey
                       ? "highlighted-selection"
                       : ""
                   }
                   onRow={(record) => {
                     return {
                       onClick: () => {
                         this.setState({ visible: true });
                         this.setRowKey(record);
                       },
                     };
                   }}
                   pagination={false}
                 >
                   <Column />
                 </Table>
               </div>
               : null

              }


        </div>
      </div>

    );
  }

  

  render() {
    return (
      <div>
        {this.state.language == "TH"? this.renderContentTH() : this.renderContentEN()}
      </div>
    );
  }
}
